import { render, staticRenderFns } from "./ALFDetails.vue?vue&type=template&id=5e66900c"
import script from "./ALFDetails.vue?vue&type=script&lang=js"
export * from "./ALFDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports